import { getConfig } from '../config/gameConfig';

/**
 * Utility function to track progress by calling the progress API
 * @param {Object} progressData - Progress data to send
 * @param {string} progressData.username - Player's username
 * @param {string} progressData.questionset - Question set identifier (e.g., "seta", "setb")
 * @param {string} progressData.action - Action type (e.g., "start", "error", "lifeline", "complete")
 * @param {string} [progressData.question] - Optional: Question identifier (e.g., "Q1", "Q5")
 * @param {string} [progressData.answer] - Optional: Answer provided or result
 * @param {string} [progressData.notes] - Optional: Additional information
 * @returns {Promise<Object>} Response from API
 */
export const trackProgress = async (progressData) => {
  if (getConfig('debugMode')) {
    console.log('🔔 trackProgress called with:', progressData);
  }
  
  try {
    const apiUrl = getConfig('progressApiUrl');
    const gameName = getConfig('gameName');
    
    if (getConfig('debugMode')) {
      console.log('📡 API URL:', apiUrl);
      console.log('🎮 Game Name:', gameName);
    }
    
    // Get current datetime in MySQL format (YYYY-MM-DD HH:MM:SS)
    const now = new Date();
    const datetime = now.getFullYear() + '-' +
      String(now.getMonth() + 1).padStart(2, '0') + '-' +
      String(now.getDate()).padStart(2, '0') + ' ' +
      String(now.getHours()).padStart(2, '0') + ':' +
      String(now.getMinutes()).padStart(2, '0') + ':' +
      String(now.getSeconds()).padStart(2, '0');
    
    // Build the request payload with required fields
    const payload = {
      datetime,
      app: gameName,
      username: progressData.username,
      questionset: progressData.questionset,
      action: progressData.action,
    };
    
    // Add optional fields if provided
    if (progressData.question) {
      payload.question = progressData.question;
    }
    if (progressData.answer) {
      payload.answer = progressData.answer;
    }
    if (progressData.notes) {
      payload.notes = progressData.notes;
    }
    
    if (getConfig('debugMode')) {
      console.log('📤 Sending payload to API:', payload);
    }
    
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    if (getConfig('debugMode')) {
      console.log('📥 API Response status:', response.status, response.statusText);
    }
    
    const result = await response.json();
    
    if (getConfig('debugMode')) {
      console.log('✅ API Response data:', result);
    }
    
    return result;
  } catch (error) {
    console.error('❌ Failed to track progress:', error);
    // Don't throw - we don't want to break the game if API fails
    return { success: false, error: error.message };
  }
};

